export type UnsubscribeFn = () => void;

export class EventEmitter<TEvents extends Record<string, unknown[]>> {
  private listeners: Map<keyof TEvents, Set<(...args: unknown[]) => void>> = new Map();

  on<K extends keyof TEvents>(
    event: K,
    callback: (...args: TEvents[K]) => void
  ): UnsubscribeFn {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }

    const callbacks = this.listeners.get(event)!;
    callbacks.add(callback as (...args: unknown[]) => void);

    return () => {
      callbacks.delete(callback as (...args: unknown[]) => void);
    };
  }

  emit<K extends keyof TEvents>(event: K, ...args: TEvents[K]): void {
    const callbacks = this.listeners.get(event);
    if (!callbacks) return;

    for (const callback of callbacks) {
      try {
        callback(...args);
      } catch (error) {
        console.error(`[EventEmitter] Error in listener for "${String(event)}":`, error);
      }
    }
  }

  removeAllListeners(event?: keyof TEvents): void {
    if (event) {
      this.listeners.delete(event);
    } else {
      this.listeners.clear();
    }
  }
}
